export const disputeTicket = (body: any) => {
  const baseURL: string = process.env.REACT_APP_API_URL as string;

  return fetch(`${baseURL}api/v1/dispute`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ticket_id: body }),
  }).then((data) => data.json());
};
